/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Trial_DescInputs */

const tr_iade_iptal_s2_trial_desc = /** @type {(inputs: Iade_Iptal_S2_Trial_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıt sonrası Platform tarafından sunulan ücretsiz kullanım dönemi (varsa).`)
};

const en_iade_iptal_s2_trial_desc = /** @type {(inputs: Iade_Iptal_S2_Trial_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The free usage period offered by the Platform after registration (if any).`)
};

const de_iade_iptal_s2_trial_desc = /** @type {(inputs: Iade_Iptal_S2_Trial_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der nach der Registrierung von der Plattform angebotene kostenlose Nutzungszeitraum (sofern vorhanden).`)
};

const ru_iade_iptal_s2_trial_desc = /** @type {(inputs: Iade_Iptal_S2_Trial_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатный период использования, предоставляемый Платформой после регистрации (при наличии).`)
};

/**
* | output |
* | --- |
* | "The free usage period offered by the Platform after registration (if any)." |
*
* @param {Iade_Iptal_S2_Trial_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_trial_desc = /** @type {((inputs?: Iade_Iptal_S2_Trial_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Trial_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_trial_desc(inputs)
	if (locale === "de") return de_iade_iptal_s2_trial_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_trial_desc(inputs)
	return tr_iade_iptal_s2_trial_desc(inputs)
});